import React, { useMemo } from "react";
import Image from "../Image/Image";

const renderImage = (props) => {
  const { ImageUrl, Title } = props;
  return (
    <React.Fragment>
      <Image
        ImageUrl={ImageUrl}
        Alt_Text={Title}
        Title={Title}
        className="giveawaypage__bookimage"
      />
    </React.Fragment>
  );
};

const GiveawayBookImage = (props) => {
  return (
    <React.Fragment>
      {useMemo(() => renderImage(props), [props.ImageUrl])}
    </React.Fragment>
  );
};

export default GiveawayBookImage;
